// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
  height: 100vh;
}

header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(90deg, #0f2027, #203a43, #2c5364);
  color: white;
  padding: 10px 20px;
  position: sticky;
  width: 100%;
  top: 0;
  z-index: 10;
}


header a{
    padding:0px 0px;
    color:#fff;
    text-decoration: none;
    font-size: 20px;
    margin-top: 10px;
    padding: 5px;
    margin-right: 40px;
   
}
header a:hover{
    color: #ffd700;
    border: 1px solid #1766ad;
    border-radius: 20px;
    padding: 10px 10px;
}
main {
  width: 100%;
  background-color: azure;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
}

footer {
 position: sticky;
 bottom: 0;
 width: 100%;
 background-color:  #203a43;
 padding: "15px 0";
font-size: "14px";
height: 60px;
}
footer p{
  color: #fff;
  font-style: italic;
  text-align: right;
  padding: 10px;
  font-size: 20px;
  margin-top: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,MAAM;EACN,WAAW;AACb;;;AAGA;IACI,eAAe;IACf,UAAU;IACV,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;;AAEtB;AACA;IACI,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;EACE,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;CACC,gBAAgB;CAChB,SAAS;CACT,WAAW;CACX,0BAA0B;CAC1B,iBAAiB;AAClB,iBAAiB;AACjB,YAAY;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,eAAe;AACjB","sourcesContent":["body {\r\n  margin: 0;\r\n  padding: 0;\r\n  height: 100vh;\r\n}\r\n\r\nheader {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  background: linear-gradient(90deg, #0f2027, #203a43, #2c5364);\r\n  color: white;\r\n  padding: 10px 20px;\r\n  position: sticky;\r\n  width: 100%;\r\n  top: 0;\r\n  z-index: 10;\r\n}\r\n\r\n\r\nheader a{\r\n    padding:0px 0px;\r\n    color:#fff;\r\n    text-decoration: none;\r\n    font-size: 20px;\r\n    margin-top: 10px;\r\n    padding: 5px;\r\n    margin-right: 40px;\r\n   \r\n}\r\nheader a:hover{\r\n    color: #ffd700;\r\n    border: 1px solid #1766ad;\r\n    border-radius: 20px;\r\n    padding: 10px 10px;\r\n}\r\nmain {\r\n  width: 100%;\r\n  background-color: azure;\r\n  display: flex;\r\n  justify-content: space-around;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n}\r\n\r\nfooter {\r\n position: sticky;\r\n bottom: 0;\r\n width: 100%;\r\n background-color:  #203a43;\r\n padding: \"15px 0\";\r\nfont-size: \"14px\";\r\nheight: 60px;\r\n}\r\nfooter p{\r\n  color: #fff;\r\n  font-style: italic;\r\n  text-align: right;\r\n  padding: 10px;\r\n  font-size: 20px;\r\n  margin-top: 8px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
